module.exports = __webpack_public_path__ + "img/children-4.04ee630a.jpg";